export type SelectedSizes = Record<string, { numberOfSizes: number }>;

export enum DefaultCollectionsEnum {
    CustomSizes = 'custom-sizes',
    OrphanSizes = 'orphan-sizes',
    SocialSizes = 'social-sizes'
}
